import { useState, useEffect } from "react";

async function sha256(message: string): Promise<string> {
    const msgBuffer = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}

export function useGravatar(email: string, size: number = 200): string {
    const [gravatarUrl, setGravatarUrl] = useState<string>("");

    useEffect(() => {
        if (email) {
            sha256(email.trim().toLowerCase()).then(hash => {
                setGravatarUrl(`https://www.gravatar.com/avatar/${hash}?s=${size}&d=retro`);
            });
        }
    }, [email, size]);

    return gravatarUrl;
}
